// Status rows (system chat messages, JSON content) that end or reopen a
// match. Read the same way for the open chat (Matches2) and for the rows
// in the lists (matches2 store), so an ending shows at once in both.

const ENDING = [
  'INTEREST_LEVEL_3',
  'PROPOSITION_INACTIVATED',
  'BLOCKED',
  'EXPIRED',
  'USER_LEFT',
  'MARKED_NO'
];

const REOPENING = [
  'INTEREST_LEVEL_0',
  'INTEREST_LEVEL_1',
  'INTEREST_LEVEL_2',
  'INTEREST_LEVEL_4',
  'MARKED_YES',
  'UNMARKED',
  'PROPOSITION_ACTIVATED',
  'UNBLOCKED',
  'RESUMED',
  // Återuppta: the user cleared their status.
  'INTEREST_LEVEL_RESET'
];

// false when the row ends the match, true when it reopens it, else null.
export function activityFromSystemMessage(content) {
  let type;
  try {
    type = JSON.parse(content)?.type;
  } catch (e) {
    return null;
  }
  if (ENDING.includes(type)) return false;
  if (REOPENING.includes(type)) return true;
  return null;
}
